
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import store from './store'
import router from './routes'
import helper from './services/helper'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#root',
    store,
    router
});

window.app = app;

if (Vue.cookie.get('auth_token') && Array.isArray(store.state.auth.roles) && !store.state.auth.roles.length) {
    axios.get('/api/auth/me')
        .then(response => {
            const payload = response || {};
            const user = payload.user || payload;

            if (!user) {
                return;
            }

            const roleNames = Array.isArray(user.user_roles)
                ? user.user_roles
                : (Array.isArray(user.roles) ? user.roles.map(r => r && r.name).filter(Boolean) : []);

            const permissionNames = Array.isArray(user.user_permissions)
                ? user.user_permissions
                : (Array.isArray(user.permissions) ? user.permissions.map(p => p && p.name).filter(Boolean) : []);

            const pref = user.user_preference || user.userPreference || {};

            store.dispatch('setAuthUserDetail', {
                id: user.id,
                uuid: user.uuid,
                email: user.email,
                name: user.name,
                username: user.username,
                avatar: user.avatar,
                roles: roleNames,
                permissions: permissionNames,
                two_factor_code: user.two_factor_code,
                color_theme: pref.color_theme || helper.getConfig('color_theme'),
                locale: pref.locale || helper.getConfig('locale'),
                direction: pref.direction || helper.getConfig('direction'),
                sidebar: pref.sidebar || helper.getConfig('sidebar')
            });
        })
        .catch(() => {
        });
}


